import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useOs } from '@mantine/hooks';

export const useInstallNotification = () => {
  const [showInstallNotification, setShowInstallNotification] = useState(false);
  const operatingSystem = useOs();

  // enable install notification through URL query
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const showInstallBanner = query.get('showInstallBanner');

  const handleClose = () => {
    setShowInstallNotification(false);
    Cookies.set('hideInstallBannerNotification', true, { expires: 3 });
  };

  useEffect(() => {
    if (!Cookies.get('hideInstallBannerNotification')) {
      const isInStandaloneMode = () =>
        'standalone' in window.navigator && window.navigator.standalone;

      if (showInstallBanner === 'ios') {
        setTimeout(() => {
          setShowInstallNotification(true);
        }, 2 * 1000);
      } else if (operatingSystem === 'ios' && !isInStandaloneMode()) {
        setTimeout(() => {
          setShowInstallNotification(true);
        }, 10 * 1000);
      }
    }
  }, [operatingSystem]);

  return { showInstallNotification, handleClose };
};
